import { AccountQuery_viewer_account_byEmail_pageSettings_tour } from '../../../../use-cases/settings/graphql/gql/AccountQuery';
import { RequestInitializeTourPayload } from '../../../tour/tourActions';

export const transformToTourReducerState = (
  tour: AccountQuery_viewer_account_byEmail_pageSettings_tour,
): RequestInitializeTourPayload => ({
  introductionTourSeen: tour.introductionTourSeen,
  seenFeatureIds: tour.featuresSeen,
});
